<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditEmploymentStatus"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editEmploymentStatus"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Employment Status</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                v-model="info.Description"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
                rows="4"
                maxlength="500"
                autocorrect="en-US"
              ></textarea>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "EditEmploymentStatus",
  props: ["showEditEmploymentStatus", "reload", "info"],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  created() {},
  methods: {
    close() {
      this.$emit("close");
    },

    // /{organization}/setup/employment/status/v1/edit
    editEmploymentStatus() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/edit`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
